<script>
import $ from "jquery";
import Statuses from "@/components/Lookup/Statuses.vue";
import Loader from "@/components/Loader.vue";
import { CONFIG } from "@/assets/JS/Config.js";

export default {
    name: "LookupForm",
    props: {
        submitted: Boolean,
        status: Object,
        loader: Object
    },
    components: {
        Statuses,
        Loader
    },
    data: () => ({
        input: "",
        classes: { formStatus: "" },
        licenseNumber: -1,
        CONFIG
    }),
    methods: {
        Submit: function() {
            const input = $("#form-lookup").find(".input").val();
            const licenseNumber = Number(input);
            this.$emit("submit", input);
            this.licenseNumber = licenseNumber;
        },
        CheckState: function(input) {
            input = $(input.target).val();
            const $submit = $("#submit");
            if (input.length > 0) {
                $submit.removeClass("submit-disabled");
            } else {
                $submit.addClass("submit-disabled");
            }
        }
    },
    updated: function() {
        let formStatus = "";
        if (this.status.error) {
            formStatus = "form-invalid";
        }
        this.classes.formStatus = formStatus;
    },
    emits: [ "submit" ]
};
</script>

<template>
    <form id="form-lookup" :class="classes.formStatus">
        <label class="hide" for="license-number"></label>
        <div class="flex">
            <input class="input" type="text" placeholder="Enter license number" :maxlength="CONFIG.licenseNumberDigitLimit" @keypress.enter.prevent="Submit()" @keyup="CheckState($event)"/>
            <div id="submit" class="btn-blue submit-disabled">
                <a class="block btn no-margin-tb" @click="Submit()">Search</a>
            </div>
        </div>

        <!-- Statuses results -->
        <Statuses
            :status="status"
            :submitted="submitted"
            :licenseNumber="licenseNumber"
        />

        <Loader :loader="this.loader"/>
    </form>
</template>